module.exports = __webpack_public_path__ + "static/email-template-login-alert-47291403de3b40b2553547142d5d522f.jpg";